import { render, staticRenderFns } from "./Boxing.vue?vue&type=template&id=08efcffd"
import script from "./Boxing.vue?vue&type=script&lang=js"
export * from "./Boxing.vue?vue&type=script&lang=js"
import style0 from "./Boxing.vue?vue&type=style&index=0&id=08efcffd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports